import React, { useEffect, useState } from "react";
import { CiFilter } from "react-icons/ci";
import { IoIosArrowBack } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import {
  exportToExcel,
  getWhatsAppAction,
} from "../../Actions/WhatsAppAction/WhatsAppAction";
import { getOrganAction } from "../../Actions/SurgeryAction/SurgeryAction";
import { getDcotorAction } from "../../Actions/DoctorAction/DoctorAction";
import { RiFileExcel2Fill } from "react-icons/ri";
import LoadingPage from "../Loading/LoadingPage";

const WhatsAppScreen = () => {
  const branchId = localStorage.getItem("branch_id");
  const getOrgan = useSelector((state) => state.getOrgan);
  const getDoctor = useSelector((state) => state.getDoctor);
  const { organs } = getOrgan;
  const { doctors } = getDoctor;

  useEffect(() => {
    dispatch(getOrganAction());
    dispatch(getDcotorAction());
  }, []);
  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "Organ Level",
      name: "organ",
    },
    {
      label: "Doctor",
      name: "doctor",
    },
    {
      label: "Name Of Hospital",
      name: "nameOfHospital",
    },

    {
      label: "Patient",
      name: "patient",
    },

    {
      label: "Zad",
      name: "zad",
    },

    {
      label: "Total Of Hospital",
      name: "totalOfHospital",
    },

    {
      label: "Helping Of Doctor",
      name: "helpingOfDoctor",
    },

    {
      label: "Total Of Surgery",
      name: "totalOfSurgery",
    },

    {
      label: "date",
      name: "date",
    },
  ];
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getWhatsAppAction(
        page,
        perPage,
        branchId,
        filter.fullname,
        filter.code,
        filter.organ,
        filter.doctor,
        filter.totalOfHospital,
        filter.patient,
        filter.zad,
        filter.helpingOfDoctor,
        filter.totalOfSurgery,
        filter.nameOfHospital,
        filter.date,
        0,
        filter.from,
        filter.to
      )
    );
  }, [perPage]);

  const getWhatsApp = useSelector((state) => state.getWhatsApp);
  const { whatsApps, total, loading } = getWhatsApp;

  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(
      getWhatsAppAction(
        event.selected+1,
        perPage,
        branchId,
        filter.fullname,
        filter.code,
        filter.organ,
        filter.doctor,
        filter.totalOfHospital,
        filter.patient,
        filter.zad,
        filter.helpingOfDoctor,
        filter.totalOfSurgery,
        filter.nameOfHospital,
        filter.date,
        0,
        filter.from,
        filter.to
      )
    );
  };
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    organ: "",
    doctor: "",
    totalOfHospital: "",
    patient: "",
    zad: "",
    date: "",
    helpingOfDoctor: "",
    totalOfSurgery: "",
    nameOfHospital: "",
    from: "",
    to: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getWhatsAppAction(
        page,
        perPage,
        branchId,
        filter.fullname,
        filter.code,
        filter.organ,
        filter.doctor,
        filter.totalOfHospital,
        filter.patient,
        filter.zad,
        filter.helpingOfDoctor,
        filter.totalOfSurgery,
        filter.nameOfHospital,
        filter.date,
        0,
        filter.from,
        filter.to
      )
    );
    setIsOpenFilter(false);
  };
  const handleClearSearch = (name) => {
    const updateFilter = { ...filter };
    updateFilter[name] = "";
    setFilter(updateFilter);
    setIsOpenFilter(false);
    dispatch(
      getWhatsAppAction(
        page,
        perPage,
        branchId,
        updateFilter.fullname,
        updateFilter.code,
        updateFilter.organ,
        updateFilter.doctor,
        updateFilter.totalOfHospital,
        updateFilter.patient,
        updateFilter.zad,
        updateFilter.helpingOfDoctor,
        updateFilter.totalOfSurgery,
        updateFilter.nameOfHospital,
        updateFilter.date,
        0,
        updateFilter.from,
        updateFilter.to
      )
    );
  };
  const handleExport = () => {
    exportToExcel(filter.from, filter.to);
  };
  const totalSurgeries = whatsApps?.reduce((sum, item) => {
    // Remove commas from the total_of_surgery value and convert it to a number
    const totalOfSurgery = parseFloat(
      item.whatsApp.total_of_surgery.replace(/,/g, "")
    );
    return sum + totalOfSurgery;
  }, 0);
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="flex justify-between items-center p-2">
            <div className="flex gap-2 items-center">
              <input
                type="date"
                className="input w-full"
                onChange={handleFilterChange}
                name="from"
                value={filter.from}
              />
              To
              <input
                type="date"
                className="input w-full"
                name="to"
                onChange={handleFilterChange}
                value={filter.to}
              />
              <button className="btn-info py-2" onClick={handleSearch}>
                <CiFilter />{" "}
              </button>
            </div>

            <div>
              <button
                onClick={handleExport}
                className="btn-success flex gap-2 p-1 items-center"
              >
                Excel <RiFileExcel2Fill />
              </button>
            </div>
          </div>

          <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-[150%]  overflow-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          {index == 2 ? (
                            <>
                              <div className="flex justify-between items-center">
                                {th.label}
                                <div
                                  className="parent-filter"
                                  onClick={() => {
                                    setIsOpenFilter(!isOpenFilter);
                                    setIndexx(index);
                                  }}
                                >
                                  <CiFilter />
                                </div>
                              </div>
                              {index == indexx && isOpenFilter && (
                                <div className="parent-input-filter ">
                                  <select
                                    name="organ"
                                    value={filter.organ}
                                    onChange={handleFilterChange}
                                    className="input text-black"
                                    id=""
                                  >
                                    <option value="">
                                      تکایە زانیاریەکە هەڵبژێرە
                                    </option>
                                    {organs.map((organ, index) => {
                                      return (
                                        <option value={organ.name} key={index}>
                                          {organ.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <div className="fotter-filter mt-2">
                                    <button
                                      className="btn-primary px-1.5 py-1 font-bold"
                                      onClick={handleSearch}
                                    >
                                      <IoCheckmark />
                                    </button>
                                    <button
                                      onClick={() => handleClearSearch(th.name)}
                                      className="btn-danger px-1.5 py-1"
                                    >
                                      <RxCross2 />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : index == 3 ? (
                            <>
                              <div className="flex justify-between items-center">
                                {th.label}
                                <div
                                  className="parent-filter"
                                  onClick={() => {
                                    setIsOpenFilter(!isOpenFilter);
                                    setIndexx(index);
                                  }}
                                >
                                  <CiFilter />
                                </div>
                              </div>
                              {index == indexx && isOpenFilter && (
                                <div className="parent-input-filter ">
                                  <select
                                    name="doctor"
                                    value={filter.doctor}
                                    onChange={handleFilterChange}
                                    className="input text-black"
                                    id=""
                                  >
                                    <option value="">
                                      تکایە زانیاریەکە هەڵبژێرە
                                    </option>
                                    {doctors.map((doctor, index) => {
                                      return (
                                        <option value={doctor.name} key={index}>
                                          {doctor.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <div className="fotter-filter mt-2">
                                    <button
                                      className="btn-primary px-1.5 py-1 font-bold"
                                      onClick={handleSearch}
                                    >
                                      <IoCheckmark />
                                    </button>
                                    <button
                                      onClick={() => handleClearSearch(th.name)}
                                      className="btn-danger px-1.5 py-1"
                                    >
                                      <RxCross2 />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="flex justify-between items-center">
                                {th.label}
                                <div
                                  className="parent-filter"
                                  onClick={() => {
                                    setIsOpenFilter(!isOpenFilter);
                                    setIndexx(index);
                                  }}
                                >
                                  <CiFilter />
                                </div>
                              </div>
                              {index == indexx && isOpenFilter && (
                                <div className="parent-input-filter ">
                                  <input
                                    type="text"
                                    className="p-2 text-black"
                                    name={th.name}
                                    onChange={handleFilterChange}
                                    value={filter[th.name]}
                                    placeholder={th.label}
                                  />
                                  <div className="fotter-filter mt-2">
                                    <button
                                      className="btn-primary px-1.5 py-1 font-bold"
                                      onClick={handleSearch}
                                    >
                                      <IoCheckmark />
                                    </button>
                                    <button
                                      onClick={() => handleClearSearch(th.name)}
                                      className="btn-danger px-1.5 py-1"
                                    >
                                      <RxCross2 />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <tbody>
                  {whatsApps?.map((item, index) => {
                    return (
                      <tr className="coustm-tr" key={index}>
                        <td className="coustm-td">{index + 1}</td>
                        <td className="coustm-td">
                          {item.patient.patient_info.code}
                        </td>
                        <td className="coustm-td">
                          {item.patient.patient_info.fullname}
                        </td>
                        <td className="coustm-td">
                          {item.follow_up_commite.length > 0
                            ? item.follow_up_commite[0].organ_level
                                .map((organ_level) => organ_level)
                                .join(" , ")
                            : ""}
                        </td>
                        <td className="coustm-td">
                          {item.follow_up_commite.length > 0
                            ? item.follow_up_commite[0].doctor
                                .map((doctor) => doctor)
                                .join(" , ")
                            : ""}
                        </td>
                        <td className="coustm-td">
                          {item?.whatsApp?.hospital_relation?.name}
                        </td>
                        <td className="coustm-td">{item.whatsApp.patient}</td>
                        <td className="coustm-td">{item.whatsApp.zad}</td>
                        <td className="coustm-td">{item.whatsApp.hospital}</td>
                        <td className="coustm-td">{item.whatsApp.doctor}</td>

                        <td className="coustm-td">
                          {item.whatsApp.total_of_surgery}
                        </td>
                        <td className="coustm-td">{item.whatsApp.date}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex gap-2 justify-between  items-center px-4">
            <div className=" text-gray-200 flex items-center gap-2 w-5/12">
              <p className="text-center w-full bg-blue-500 py-1 rounded-md shadow-md">
                Total Patient: {total}
              </p>
              <p className="text-center w-full bg-teal-500 py-1 rounded-md shadow-md">
                Total Cost: {totalSurgeries?.toLocaleString()}
              </p>
            </div>
            <div className="flex gap-3 items-center justify-end mt-2 w-full">
              <div className="mt-2 md:w-2/12">
                <select
                  className="outline-none border-blue-400 rounded-sm border py-1 w-full"
                  value={perPage}
                  onChange={(e) => setPerPage(e.target.value)}
                >
                  {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                    (perPage, index) => {
                      return (
                        <option value={perPage} key={index}>
                          {perPage}
                        </option>
                      );
                    }
                  )}
                </select>
              </div>
              <ReactPaginate
                breakLabel={<span className="break">...</span>}
                nextLabel={
                  <p className="  arrow rotate-180">
                    <IoIosArrowBack />
                  </p>
                }
                onPageChange={onPageChange}
                forcePage={page}
                pageRangeDisplayed={5}
                pageCount={total / perPage}
                previousLabel={
                  <p className=" arrow">
                    <IoIosArrowBack />
                  </p>
                }
                renderOnZeroPageCount={null}
                containerClassName="paginate-container"
                activeClassName="active"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppScreen;
